import type { Camera } from '@/lib/api/cameras-api'

export type { Camera }

/**
 * Trạng thái khung hình của một camera, suy từ chính thẻ `<img>` đang phát:
 * `loading` khi chưa có khung nào, `playing` khi đã nhận được khung, `error`
 * khi trình duyệt báo tải thất bại, `unconfigured` khi camera chưa có token
 * stream để mà tải.
 *
 * Không có cột trạng thái nào ở backend: trạng thái thật của camera chỉ biết
 * được khi thực sự kéo khung hình, nên lưu lại một cột "online" sẽ luôn lạc hậu.
 */
export type CameraStreamState =
    | 'unconfigured'
    | 'loading'
    | 'playing'
    | 'error'
    /** Cố ý ngắt kết nối (vd đang mở chi tiết một camera khác). */
    | 'paused'

/**
 * Rút gọn giữa token để hiển thị trên thẻ: token là thứ xác thực camera nên
 * không phơi trọn ra màn hình (và ảnh chụp màn hình) — tài liệu tích hợp yêu
 * cầu che token. Giá trị đầy đủ vẫn có trong ô nhập lúc sửa.
 */
export function shortenCameraToken(token: string, keep = 8): string {
    if (token.length <= keep * 2) return token
    return `${token.slice(0, keep)}…${token.slice(-keep)}`
}
